function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 84.8 84.8",
    style: {
      enableBackground: "new 0 0 84.8 84.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#e4e4e4"
    },
    cx: 42.4,
    cy: 42.4,
    r: 42.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ececec"
    },
    d: "M64.7 63.4H20.4c-1.5 0-2.8-1.2-2.8-2.8v-37c0-1.5 1.2-2.8 2.8-2.8h44.3c1.5 0 2.8 1.2 2.8 2.8v37c0 1.5-1.3 2.8-2.8 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dedede"
    },
    d: "M19.5 60.6V21c-1.1.4-1.8 1.4-1.9 2.6v37c0 1.5 1.2 2.8 2.8 2.8h44.3c1.2 0 2.2-.7 2.6-1.8H20.4c-.5 0-1-.4-.9-1-.1 0-.1 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M64.7 61.5H20.4c-.5 0-.9-.4-.9-.9V31c0-.5.4-.9.9-.9h44.3c.5 0 .9.4.9.9v29.6c0 .5-.4.9-.9.9zM63.8 26.4H30.5c-.5 0-.9-.4-.9-.9s.4-.9.9-.9h33.3c.5 0 .9.4.9.9s-.4.9-.9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b5b5b5"
    },
    d: "M57.3 44.9H46.2c-.5-.1-.9-.5-.8-1 0-.4.4-.8.8-.8h11.1c.5.1.9.5.8 1 0 .4-.3.8-.8.8zM60.9 40.9H46.5c-.7 0-1.2-.2-1.2-.9s.5-.9 1.2-.9h14.4c.7 0 1.2.3 1.2.9s-.5.9-1.2.9zM52.7 48.6h-6.5c-.5-.1-.9-.5-.8-1 0-.4.4-.8.8-.8h6.5c.5.1.9.5.8 1 0 .4-.4.8-.8.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ccc"
    },
    cx: 21.3,
    cy: 25.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ccc"
    },
    cx: 24.1,
    cy: 25.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ccc"
    },
    cx: 26.8,
    cy: 25.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c8c8c8"
    },
    d: "m43.6 54.4-4.5-1.9c-.7-.3-1.1-1-1.1-1.7v-3.1h-7.4v3.1c0 .7-.4 1.4-1.1 1.7L25 54.4c-1 .4-1.7 1.4-1.7 2.6v4.6h22.2V57c-.2-1.2-.9-2.2-1.9-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b9b9b9"
    },
    d: "M30.5 47.7v3.1c0 .2 0 .3-.1.5 2.3 1.4 5.2 1.4 7.5 0 0-.2-.1-.3-.1-.5v-3.1h-7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dadada"
    },
    d: "M34.2 36.6c-3.1 0-5.5 2.1-5.5 4.6v3.7c0 3.1 2.5 5.5 5.5 5.5 3.1 0 5.5-2.5 5.5-5.5v-3.7c.1-2.5-2.4-4.6-5.5-4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c8c8c8"
    },
    d: "M31.5 44.9v-4.6c0-1.5.9-2.9 2.2-3.7-2.8.2-5 2.2-5 4.6v3.7c0 3.1 2.5 5.5 5.5 5.5.5 0 .9-.1 1.4-.2-2.4-.6-4.1-2.8-4.1-5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b9b9b9"
    },
    d: "M45.3 59.7H28.7c-2 0-3.7-1.7-3.7-3.7v-1.7h-.1c-1 .4-1.7 1.4-1.7 2.6v4.6h22.2v-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "m61.9 47.9-11.2 3.9c-.4.1-.7.6-.6 1 .9 8 5.2 15.1 11.9 19.5.3.2.7.2 1 0 6.7-4.4 11.1-11.6 11.9-19.6.1-.4-.2-.9-.6-1l-11.2-3.9c-.4-.1-.8-.1-1.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d1d1d1"
    },
    d: "M61.6 63.6c-.2 0-.5-.1-.7-.3l-3.8-3.8c-.4-.4-.4-.9 0-1.3s.9-.4 1.3 0l3.1 3.1 5.3-5.3c.4-.4.9-.4 1.3 0s.4.9 0 1.3l-6 6c-.1.2-.3.3-.5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5f5"
    },
    d: "m53.6 50.8-2.9 1c-.4.1-.7.6-.6 1 .9 8 5.2 15.1 11.9 19.5.3.2.7.2 1 0 .6-.4 1.2-.8 1.7-1.2-8.2-6.5-10.5-15.8-11.1-20.3z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCircle);
export default __webpack_public_path__ + "static/media/profile-circle.14d916140e45f59d923ff2d6c1a3577a.svg";
export { ForwardRef as ReactComponent };